import { render, staticRenderFns } from "./amapa.vue?vue&type=template&id=77b2c55e"
import script from "./amapa.vue?vue&type=script&lang=js"
export * from "./amapa.vue?vue&type=script&lang=js"
import style0 from "./amapa.vue?vue&type=style&index=0&id=77b2c55e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports